import styled from 'styled-components';
import { customMedia } from 'styles/utils';
import { FormField, ItemsWrapper } from 'libs/forms/styles';
import Icon from 'components/Icon';
import { OutsideWrapper } from 'components/Select/Select.styled';
import {
  MobileBottomNavHeight,
  MobileFrameHeaderHeight,
} from 'styles/constants';

export const UserSettingsWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  min-width: 38rem;
  padding: 0 1rem;
  background-color: ${props => props.theme.color.wfWhite};
  border: ${props =>
    props.borderless ? 'none' : ` 1px solid ${props.theme.color.wfGrey300}`};
  padding-bottom: 1rem;

  ${customMedia.lessThan('medium')`
    margin-top: auto;
    position: fixed;
    top: ${MobileFrameHeaderHeight}px;
    left: 0;
    width: 100vw;
    height: calc(100vh - ${MobileBottomNavHeight}px - ${MobileFrameHeaderHeight}px);
    min-width: auto;
    transform: translateX(0px);
    box-shadow: none;
  `};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem;
  ${customMedia.lessThan('medium')`
    padding: 0.5rem;
  `};
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem 0.5rem 0.5rem 0.8rem;
  ${FormField} {
    min-height: auto;
    width: 70%;
    padding: 0 1rem 0 0;
  }
  ${ItemsWrapper} {
    margin-top: 0;
    border: 0;
  }
  ${customMedia.lessThan('medium')`
    flex-direction: column;
    padding: 0;
    ${FormField} {
      margin-bottom: ${props => props.theme.space[2]};
      min-height: auto;
    } 
  `};
`;

export const ParticipantsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0.5rem 1rem;
  ${customMedia.lessThan('medium')`
    padding: ${props => props.theme.space[4]} 0;
    border-top: 1px solid ${props => props.theme.color.wfGrey300};
    margin-top: ${props => props.theme.space[4]};
  `};
`;

export const ParticipantsListWrapper = styled.table`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 14rem;
  overflow-y: auto;

  ${customMedia.lessThan('medium')`
    max-height: 24rem;
  `};
`;

export const ParticipantsRowWrapper = styled.tr`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 92vw;
  min-height: 4rem;
`;

export const AvatarBlockWrapper = styled.td`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 1rem;
  min-width: 55%;
`;

export const AvatarColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  width: 280px;
  max-width: 280px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem;
  border-top: 1px solid ${props => props.theme.color.wfGrey300};
  box-shadow: 0 -6px 4px -5px #fff;
`;

export const RemoveWrapper = styled.td`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  margin: 0 1rem;
  cursor: pointer;
`;

export const RemoveIcon = styled(Icon)`
  &:hover {
    color: ${props =>
      !props.noColorChangeOnHover && props.theme.color.wfOrange};
  }
`;

export const NativeSelectWrapper = styled(OutsideWrapper)`
  width: 128px;
`;

// FIXME This is a temporary solution, the native select cannot be fully styled. Probably it will be replaced on the near future.
export const NativeSelect = styled.select`
  /* height: 48px; */
  padding: 8px 48px 8px 16px;
  border: 0px;
  font-size: ${props => props.theme.font.size.xsmall};
  font-weight: ${props => props.theme.font.weight.xbold};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 100%;

  /* Remove default arrow */
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
`;

export const CaretWrapper = styled.div`
  position: absolute;
  top: calc(50% - 15px);
  right: 8px;
  pointer-events: none;
`;
